import { CheckNormalIcon, CircleSolidIcon, StackIcons } from '@dhl-ui/icons'

/**
 * When you compose the selectable variant and want to hide the form element itself you can place
 * this icon for the prop `secondaryIcon` when its selected.
 */
export const ListItemSelectedIcon = () => (
  <StackIcons variant="centered">
    <CircleSolidIcon color="success" />
    <CheckNormalIcon sx={{ color: 'common.white' }} />
  </StackIcons>
)
